import { useMemo } from 'react';
import { useGetLlmModels } from '../agent-chat-module/hooks/use-gpt-chat';

/** Chat models an agent can use: Blocks models, and the user's own validated models. */
export function useAgentChatModels() {
  const { data: llmModels, isLoading: isLoadingLlmModels } = useGetLlmModels();

  const availableChatModels = useMemo(
    () =>
      (llmModels || []).filter(
        (model) => model.model_type === 'chat' && model.is_system !== false
      ),
    [llmModels]
  );

  const availableCustomChatModels = useMemo(
    () =>
      (llmModels || []).filter(
        (model) =>
          model.model_type === 'chat' &&
          model.is_system === false &&
          model.is_active !== false &&
          model.status === 'validated'
      ),
    [llmModels]
  );

  return { availableChatModels, availableCustomChatModels, isLoadingLlmModels };
}
